// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6f2e4","label":"_9e804","spinner":"cc103","icon":"_4e84a","white":"_8163c"};